import React, {PureComponent} from 'react';
import { getJwt } from '../../services/authService';
import http from '../../services/httpService';


export default class InactivePlanPreview extends PureComponent {
    state = {
        planName: '',
        expiredDate: '',
        selectedSourceId: ''
    }

    convertDate = (unix_timestamp) => {
// Create a new JavaScript Date object based on the timestamp
// multiplied by 1000 so that the argument is in milliseconds, not seconds.

        let miliseconds = unix_timestamp * 1000;

        let toLocal = new Date(miliseconds).toLocaleDateString("en-US");

        let objectDate = new Date(toLocal);
        let fullDate = objectDate.toString();

        let year = fullDate.substring(11, 15);
        let month = fullDate.substring(4, 7);
        let day = fullDate.substring(8, 10);

        // console.log('convertDate: ', day + '. ' + month + ' ' + year)

        return month + ' ' + year

    }

    getSubscriptions = async () => {
        let projectId = this.props.selectedSourceNode.id;
        try{
            const result = await http.get('api/user/' + this.props.userId + '/project/' + projectId + '/customers/get_subscriptions_project?page=100?page=1', {headers: {authorization: getJwt()}});
            // await console.log('Evo ga rezultat za project subscriptions: ', result.data.subscriptions)
            const data = await result.data.subscriptions;
            if(data && data.length){
                let planName = await data[0].subscriptionItems && data[0].subscriptionItems.length && data[0].subscriptionItems[0].plan_id ?
                    String(data[0].subscriptionItems[0].plan_id.replace('_', ' ')) : '';
                let expiredDate = await data[0].currentTermEnd ? this.convertDate(data[0].currentTermEnd) : '';
                await this.setState({
                    planName,
                    expiredDate,
                    selectedSourceId: this.props.selectedSourceNode.id
                })
            }
        }catch{
            toastr.error("Error with getting workspace subscriptions, please reload page.")
        }
    }

    componentDidMount() {
        this.getSubscriptions();
    }

    componentDidUpdat() {
        if(this.props.selectedSourceNode.id !== this.state.selectedSourceId){
            this.getSubscriptions();
        }
    }

    render() {
        return(
            <div className='no-contacts-container panel-container margin-top-20'>
                <img className='margin-top-30' src="/img/inactive-plan-logo.png" alt='Inactive Plan image'/>

                <p className='small'>Your <strong>{this.props.selectedSourceNode.name}</strong> Workspace is currently inactive.</p>
                <p className='small margin-top-10 margin-bottom-20'>Your previous subscription on this Workspace was <strong>{this.state.planName}</strong> and
                    has expired <strong>{this.state.expiredDate}</strong>.</p>
                <p className='small'>To get access to all the channels and data on this workspace choose a new Emitto Plan.</p>


                {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
                <div className='flex-direction-row justify-content-center'>
                    <button
                        onClick={() => this.props.history.push('/subscription-plans')}
                        className=' btn-action margin-bottom-20 margin-top-20'>
                        Get Started
                    </button>
                </div>
            </div>
        )
    }
}